<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  @if (type === 'Add') {
    <div i18n="@@addNewPositioning">Add New Competitor Positioning</div>
  }
  @if (type !== 'Add') {
    <div i18n="@@editPositioning">Edit Competitor Positioning</div>
  }
  <mat-icon (click)="closeDialog()" class="cursor" i18n-label="@@closeDialogIcon" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <form [formGroup]="addPositioningForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@CompetitorChallengeLabel">Competitor challenge</mat-label>
        <input data-testid="CompetitorChallenge" i18n-placeholder="@@CompetitorChallengePlaceholder" matInput id="CompetitorChallenge" placeholder="Competitor challenge" name="CompetitorChallenge" formControlName="CompetitorChallenge" required />
        <mat-error>
          @if (!addPositioningForm.get('CompetitorChallenge').valid && addPositioningForm.get('CompetitorChallenge').touched) {
            @if (addPositioningForm.get('CompetitorChallenge').errors && addPositioningForm.get('CompetitorChallenge').errors['required'] || addPositioningForm.get('CompetitorChallenge').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@ProductOfferLabel">Product offer</mat-label>
        <input data-testid="ProductOffer" i18n-placeholder="@@ProductOfferPlaceholder" matInput id="ProductOffer" placeholder="Product offer" name="ProductOffer" formControlName="ProductOffer" required />
        <mat-error>
          @if (!addPositioningForm.get('ProductOffer').valid && addPositioningForm.get('ProductOffer').touched) {
            @if (addPositioningForm.get('ProductOffer').errors && addPositioningForm.get('ProductOffer').errors['required'] || addPositioningForm.get('ProductOffer').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@productValueLabel">Product value</mat-label>
        <input data-testid="ProductValue" i18n-placeholder="@@productValuePlaceholder" matInput id="ProductValue" placeholder="Product value" name="ProductValue" formControlName="ProductValue" required />
        <mat-error>
          @if (!addPositioningForm.get('ProductValue').valid && addPositioningForm.get('ProductValue').touched) {
            @if (addPositioningForm.get('ProductValue').errors && addPositioningForm.get('ProductValue').errors['required'] || addPositioningForm.get('ProductValue').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>

      <div i18n="@@supportMaterials" class="mat-subtitle-1 medium-font" matTooltip ellipsisTooltip>Support Materials</div>
      <mat-divider class="mb-24"></mat-divider>

      <div class="d-flex align-items-base">
        @if (!fileIconOn) {
          <mat-form-field class="flex-grow" appearance="outline">
            <mat-label i18n="@@linkLabel">Link</mat-label>
            <input data-testid="add_edit_link" matInput id="link" placeholder="Link" i18n-placeholder="@@linkPlaceholder" name="link" formControlName="link" required />
            <mat-error>
              @if (!addPositioningForm.get('link').valid && addPositioningForm.get('link').touched) {
                @if (addPositioningForm.get('link').errors && addPositioningForm.get('link').errors['required']) {
                  <span i18n="@@inValidRequiredField">This field is required</span>
                }
              }
              @if (addPositioningForm.get('link').errors && addPositioningForm.get('link').errors['pattern']) {
                <span i18n="@@inValidLink">Please add correct link!</span>
              }
            </mat-error>
          </mat-form-field>
        }
        @if (fileIconOn) {
          <mat-form-field (click)="imgFileInput.click();" class="flex-grow" appearance="outline">
            <mat-label i18n="@@fileLabel">File *</mat-label>
            <input data-testid="add_edit_file" matInput id="file" placeholder="File *" i18n-placeholder="@@filePlaceholder" name="file" formControlName="file" required />
            <mat-error>  
              @if (!addPositioningForm.get('file').valid && addPositioningForm.get('file').touched) {
                @if (addPositioningForm.get('file').errors && addPositioningForm.get('file').errors['required']) {
                  <span i18n="@@inValidRequiredField">This field is required</span>
                }
              }
            </mat-error>
          </mat-form-field>
        }
        <mat-icon class="{{!fileIconOn ? 'cursor off-icon-color ' : 'cursor on-icon-color'}}" (click)="imgFileInput.click();toggleIcon('file')" i18n-label="@@fileIconLabel" aria-label="File">insert_drive_file</mat-icon>
        <mat-icon class="{{fileIconOn ? 'cursor off-icon-color ' : 'cursor on-icon-color'}}" (click)="toggleIcon('link')" i18n-label="@@linkIconLabel" aria-label="Link">insert_link</mat-icon>
        <mat-icon data-testid="add_file_button" (click)="addFileOrListToList()" class="cursor add-icon add" svgIcon="add" aria-hidden="false" i18n-label="@@addFileIcon" aria-label="Add file"></mat-icon>
        <input accept=".png, .jpg, .jpeg, .txt, .html, .pdf, .rtf, .doc, .docx, .ppt, .pptx, .xls, .xlsx" hidden type="file" onclick="this.value = null" #imgFileInput (change)="previewImage($event.target.files)"/>
      </div>

      @for (item of allFiles; track item; let index = $index) {
        <div class="mat-caption d-flex mb-28">
          @if (item.type === utils.supportMaterials.Link) {
            <span class="mr-auto" matTooltip ellipsisTooltip>{{truncate(item.file)}}</span>
          }
          @if (item.type === utils.supportMaterials.File) {
            <span class="mr-auto" matTooltip ellipsisTooltip>{{truncate(item.file.name)}}</span>
          }
          @if (item.type === utils.supportMaterials.File) {
            <mat-icon class="on-icon-color" i18n-label="@@fileIconLabel" aria-label="File">insert_drive_file</mat-icon>
          }
          @if (item.type === utils.supportMaterials.Link) {
            <mat-icon class="on-icon-color" i18n-label="@@linkIconLabel" aria-label="Link">insert_link</mat-icon>
          }
          <mat-icon class="cursor mr-35" (click)="deleteFromFileList(index)" color="warn" i18n-label="@@deleteIcon" aria-label="Delete">delete_outline</mat-icon>
        </div>
      }

      @for (item of positioning?.supportMaterial ; track item; let index = $index) {
        <div class="mat-caption d-flex mb-28">
          @if (item.type === utils.supportMaterials.Link) {
            <span class="mr-auto" matTooltip ellipsisTooltip>{{truncate(item.path)}}</span>
          }
          @if (item.type !== utils.supportMaterials.Link) {
            <span class="mr-auto" matTooltip ellipsisTooltip>{{truncate(item.fileName)}}</span>
          }
          @if (item.type !== utils.supportMaterials.Link) {
            <mat-icon class="on-icon-color" i18n-label="@@fileIconLabel" aria-label="File">insert_drive_file</mat-icon>
          }
          @if (item.type === utils.supportMaterials.Link) {
            <mat-icon class="on-icon-color" i18n-label="@@linkIconLabel" aria-label="Link">insert_link</mat-icon>
          }
          <mat-icon class="cursor" (click)="deletePositioningMaterial(item.id, index)" color="warn" i18n-label="@@deleteIcon" aria-label="Delete">delete_outline</mat-icon>
          <a href="{{item.path}}" target="_blank">
            <mat-icon color="accent" class="cursor ml-11" i18n-label="@@downloadIcon" aria-label="Download">get_app</mat-icon>
          </a>
        </div>
      }
    </div>

    <div>
      @if (type === 'Add') {
        <button i18n="@@add" data-testid="add_positioning_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Add</button>
      }
      @if (type !== 'Add') {
        <button i18n="@@save" data-testid="edit_positioning_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Save</button>
      }
    </div>
  </form>
</mat-dialog-content>